export enum Estado {
  Cargando,
  Reproduciendo,
  Parado
}

export enum Calidad {
  LOW = "low",
  MEDIUM = "medium",
  HIGH = "high"
}

export interface NewSessionData {
  sessionId: string;
  // Add other session data properties if needed
}

export interface AvatarConfig {
  id: string;
  voice_id: string;
  quality: Calidad;
  system_prompt?: string;
}

export type AsyncFunction = () => Promise<void>;
